import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { INVALID_GPM } from "../../configurations/MessageConstants";

function FieldWells({ well, index, updateWellDetails }) {
  const [active, setActive] = useState(well.activeWell);
  const [isElectric, setElectric] = useState(well.isElectricWell);
  const [ugpm, setUgpm] = useState(well.ugpm);

  useEffect(() => {
    setActive(well.activeWell);
    setElectric(well.isElectricWell);
    setUgpm(well.ugpm);
  }, [well]);

  useEffect(() => {
    updateWell();
  }, [active, isElectric, ugpm]);

  const toggleCheckbox = (e) => {
    setActive(!active);
  };

  const toggleElectricCheckbox = () => {
    setElectric(!isElectric);
  };

  const onWellUgpmChange = (e) => {
    setUgpm(e.target.value);
  };

  const updateWell = () => {
    updateWellDetails(
      {
        ...well,
        activeWell: active,
        isElectricWell: isElectric,
        ugpm: ugpm ? parseInt(ugpm) : parseInt(well.gpm),
      },
      index
    );
  };

  return (
    <tr className="field-well-rows">
      <td>
        <b>
          <span className={"wellcolor" + index}>Well {index + 1}</span>
        </b>
      </td>
      <td>
        <Form.Check type="switch" checked={active} onChange={toggleCheckbox} />
      </td>
      <td>
        <Form.Check
          type="switch"
          checked={isElectric}
          onChange={toggleElectricCheckbox}
        />
      </td>
      <td>
        <Form.Control type="text" name={"wellGPM"} value={well.gpm} readOnly />
      </td>
      <td>
        <Form.Control
          type="text"
          name={"updateWellGPM"}
          value={ugpm}
          onChange={onWellUgpmChange}
          pattern="^[0-9]*"
          maxLength="4"
        />
        <Form.Control.Feedback type="invalid">
          {INVALID_GPM}
        </Form.Control.Feedback>
      </td>
    </tr>
  );
}

export default FieldWells;
